import { render, staticRenderFns } from "./PaymentTermsList.vue?vue&type=template&id=d2501070"
import script from "./PaymentTermsList.vue?vue&type=script&lang=js"
export * from "./PaymentTermsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports